import { PlatformStatusQuery } from '@/platform-status/queries/platform-status.query';

import { PlatformComponentItem } from './components/platform-component-item';
import { PlatformInformation } from './components/platform-information';
import { PlatformStatusOverallStatus } from './components/platform-status-overall-status';
import { Shell } from './components/shell';

const DAYS_RANGE = 90;

export function PlatformStatusPage() {
  const platformStatusQuery = PlatformStatusQuery.useQuery(
    { daysRange: DAYS_RANGE },
    {
      refetchInterval: 30_000, // Refetch every 30 seconds
    },
  );

  if (platformStatusQuery.isLoading) {
    return null;
  }

  if (platformStatusQuery.isError || !platformStatusQuery.data) {
    throw platformStatusQuery.error;
  }

  const timeBasedPlatformStatus = platformStatusQuery.data;

  return (
    <Shell>
      <div className="space-y-6 py-8">
        <PlatformStatusOverallStatus
          timeBasedPlatformStatus={timeBasedPlatformStatus}
          updatedAt={new Date(platformStatusQuery.dataUpdatedAt)}
        />

        {timeBasedPlatformStatus.platformComponents.map((platformComponent) => (
          <PlatformComponentItem
            key={platformComponent.id}
            platformComponent={platformComponent}
          />
        ))}

        <PlatformInformation />
      </div>
    </Shell>
  );
}
